import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMultipleChoice = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1,
			width: 6,
			height: 6,
			rx: 2,
			stroke: "#999999",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 11,
			width: 6,
			height: 6,
			rx: 2,
			stroke: "#999999",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 11,
			width: 6,
			height: 6,
			rx: 2,
			stroke: "#999999",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 1,
			width: 6,
			height: 6,
			rx: 2,
			stroke: "#999999",
			strokeWidth: 2
		})
	]
});
export default SvgMultipleChoice;
